import './history-modal.scss';

import { Modal, Table } from 'antd';

import { Button, CircledImage } from '@/components/Shared/ui';
import { BANKS_ICONS_NAMES } from '@/constants';

import { type THistoryData, historyTableData } from './table-data';

type TProps = {
  isOpened: boolean;
  onClose: () => void;
  bankLogo: string;
  subtitle: string;
  historyList: THistoryData[];
};

const HistoryModal: React.FC<TProps> = ({
  isOpened,
  onClose,
  bankLogo,
  subtitle,
  historyList
}) => {
  const bankIcon =
    BANKS_ICONS_NAMES[bankLogo as keyof typeof BANKS_ICONS_NAMES]?.icon;

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      centered
      mask={{ closable: true }}
      className="history-modal"
      classNames={{
        header: 'history-modal__header'
      }}
      title={
        <>
          История изменений
          <div className="history-modal__subtitle">
            <CircledImage src={bankIcon || bankLogo} alt={subtitle} size={32} />
            {subtitle}
          </div>
        </>
      }
      open={isOpened}
      onCancel={handleClose}
      footer={null}
    >
      <Table
        className="history-modal__table"
        rowKey={(record) => record.date.toString()}
        columns={historyTableData}
        pagination={{
          hideOnSinglePage: true,
          pageSize: 10
        }}
        dataSource={historyList}
      />

      <div className="history-modal__actions">
        <Button onClick={handleClose} className="history-modal__cancel">
          Закрыть
        </Button>
      </div>
    </Modal>
  );
};

export default HistoryModal;
